/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckoutSessionResponse
 */
export interface CheckoutSessionResponse {
    /**
     * The ID of the user this session is for
     * @type {string}
     * @memberof CheckoutSessionResponse
     */
    user: string;
    /**
     * The ID of the domain this session is for
     * @type {string}
     * @memberof CheckoutSessionResponse
     */
    domain: string;
    /**
     * The ID of the checkout session (expires ~30 min after creation)
     * @type {string}
     * @memberof CheckoutSessionResponse
     */
    checkoutSessionId: string;
    /**
     * Deprecated: use url instead. The Stripe subscription ID if already created.
     * @type {string}
     * @memberof CheckoutSessionResponse
     * @deprecated
     */
    subscriptionId: string;
    /**
     * Checkout URL for client-side redirect
     * @type {string}
     * @memberof CheckoutSessionResponse
     */
    url: string;
    /**
     * Number of days in the free trial period
     * @type {number}
     * @memberof CheckoutSessionResponse
     */
    trialPeriodDays: number;
    /**
     * Client Secret for embedded checkout form, null for hosted mode
     * @type {string}
     * @memberof CheckoutSessionResponse
     */
    clientSecret?: string;
}

/**
 * Check if a given object implements the CheckoutSessionResponse interface.
 */
export function instanceOfCheckoutSessionResponse(value: object): value is CheckoutSessionResponse {
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('domain' in value) || value['domain'] === undefined) return false;
    if (!('checkoutSessionId' in value) || value['checkoutSessionId'] === undefined) return false;
    if (!('subscriptionId' in value) || value['subscriptionId'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('trialPeriodDays' in value) || value['trialPeriodDays'] === undefined) return false;
    return true;
}

export function CheckoutSessionResponseFromJSON(json: any): CheckoutSessionResponse {
    return CheckoutSessionResponseFromJSONTyped(json, false);
}

export function CheckoutSessionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckoutSessionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'user': json['user'],
        'domain': json['domain'],
        'checkoutSessionId': json['checkoutSessionId'],
        'subscriptionId': json['subscriptionId'],
        'url': json['url'],
        'trialPeriodDays': json['trialPeriodDays'],
        'clientSecret': json['clientSecret'] == null ? undefined : json['clientSecret'],
    };
}

export function CheckoutSessionResponseToJSON(json: any): CheckoutSessionResponse {
    return CheckoutSessionResponseToJSONTyped(json, false);
}

export function CheckoutSessionResponseToJSONTyped(value?: CheckoutSessionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user': value['user'],
        'domain': value['domain'],
        'checkoutSessionId': value['checkoutSessionId'],
        'subscriptionId': value['subscriptionId'],
        'url': value['url'],
        'trialPeriodDays': value['trialPeriodDays'],
        'clientSecret': value['clientSecret'],
    };
}

